module.exports = __webpack_public_path__ + "img/info_icon.e6a1d6bc.svg";